// extracted by css-extract-rspack-plugin
export default {"modal":"leimzO","content":"WPgptJ","header":"TZU0uh","heading":"eRS6bI"};